
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 7c5.8-3 9.5-1.5 12-4 0 0 1 10.7-4 14-2.4 1.5-5.2 2.2-8 2-.5.6-.8 1.3-1 2-.2.6-2.2.7-2 0 1.9-5.9 5.6-9.2 9-12 0 0-7.1 1.9-9 8 0 0-2.8-7 3-10z"}})])
          )
        }
      }
    